<template>
  <div v-if="readValue">
    <p
      v-for="(item,index) in readValue"
      :key="index"
    >
      {{ item }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'TextareaRead',
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      readValue: []
    };
  },
  watch: {
    value: function (newVal) {
      if (newVal) {
        const _arr = newVal.split('\n');
        _arr.forEach((item, key) => {
          this.$set(this.readValue, key, item);
        });
      }
    }
  },
  created () {
    if (this.value) {
      const _arr = this.value.split('\n');
      _arr.forEach((item, key) => {
        this.$set(this.readValue, key, item);
      });
    }
  }
};
</script>

<style lang="scss">
.c-form__input--read .el-textarea__inner {
  resize: none;
  border: 0;
}
</style>
